
<template>
    <v-row class="ma-0 pb-offset">
		<quotations-scheduling-options>
		</quotations-scheduling-options>
		<v-col class="pa-0 pt-4" cols="12">
			<crud
				title="Scheduling Mail automatiche"
				action-icon='repeat'
				model-def='quotationsmailsschedules'
				action-position='absolute'
				url="quotationsmailsschedules-filters"
			></crud>
		</v-col>
	</v-row>
</template>
<script>
	import QuotationsSchedulingOptions from '@/components/modules/quotations/settings/QuotationsSchedulingOptions'

	export default {
		name:'quotations-scheduling',
		components: {
			QuotationsSchedulingOptions
		},
		
		data() {
			return {
			}
		},
	}
</script>
